import { Star } from "@phosphor-icons/react";

export const RatingStars = ({ value = 0, size = 16, testId = "rating-stars" }) => {
  const rounded = Math.round(value);
  return (
    <div data-testid={testId} className="flex items-center gap-0.5" aria-label={`${value} out of 5 stars`}>
      {[1, 2, 3, 4, 5].map((star) => (
        <Star
          key={star}
          data-testid={`${testId}-star-${star}`}
          size={size}
          weight="fill"
          className={star <= rounded ? "text-[#FF5500]" : "text-zinc-300"}
        />
      ))}
    </div>
  );
};